import styled from 'styled-components';

export const StyledPath = styled.path`
  transition: all 250ms ease-out;
  cursor: pointer;
`;
